import apisetup from "./apisetup";
import api1 from "./api1";
import api2 from "./api2";
import SelfPublishAPI from "./apiSelfPublish.js";
import customCharacterAPI from "./apiCustomCharacter.js";
import apiProfile from "./apiProfile.js";
import apiDashboard from "./apiDashboard.js";
import apiHandPrint from "./apiHandPrint";

window.api = {
  ...apisetup,
  ...api1,
  ...api2,
  ...SelfPublishAPI,
  ...customCharacterAPI,
  ...apiProfile,
  ...apiDashboard,
  ...apiHandPrint,
};
// Site-wide data that doesn't change while the site is open. Header and
// Footer are rendered inside every page, so they remount (and used to
// refetch) on each route change. Fetch these once and share the result;
// a failed or empty response is dropped so the next caller retries.
const fetchOnce = (fn) => {
  let pending = null;
  return function (...args) {
    if (!pending) {
      pending = fn.apply(this, args).then(
        (res) => {
          if (!res || !res.data) pending = null;
          return res;
        },
        (err) => {
          pending = null;
          throw err;
        },
      );
    }
    return pending;
  };
};
// Share one in-flight request between callers asking for the same thing
// at the same moment (no caching once it settles).
const shareInflight = (fn) => {
  const pending = new Map();
  return function (...args) {
    const key = JSON.stringify(args);
    if (!pending.has(key)) {
      pending.set(
        key,
        fn.apply(this, args).finally(() => pending.delete(key)),
      );
    }
    return pending.get(key);
  };
};
api.getBookDetails = shareInflight(api.getBookDetails);

["getHeaderMenue", "getCMSList", "getcmsInfo"].forEach((name) => {
  api[name] = fetchOnce(api[name]);
});

export default api;
